import { Component } from '@angular/core';
import { AvatarComponent } from "../../../../shared/components/avatar/avatar.component";
import { TagComponent } from '../../../../shared/components/tag/tag.component';

@Component({
  selector: 'app-basic-profile-view',
  standalone: true,
  imports: [AvatarComponent, TagComponent],
  templateUrl: './basic-profile-view.component.html',
  styleUrl: './basic-profile-view.component.scss'
})
export class BasicProfileViewComponent {

  userData: any = {
    name: 'Adrianna Philips',
    position: 'Senior Mechanical Engineer',
    email: 'audriannaphilips@everyeng.com',
    phone: '+91 20 10 21 20162',
    location: 'India',
    imageUrl: 'images/instructor-avatar-1.webp',
  };


  myInterests: any = [
    {
      title: 'Industry Domain',
      items: ['Oil & Gas', 'Energy', 'Mining', 'Construction', 'Manufacturing']
    },
    {
      title: 'Engineering disciplines',
      items: ['Automotive engineering', 'Robotics', 'HVAC systems']
    }
  ];

  industryDomains: any = ['Oil & Gas', 'Energy', 'Mining', 'Construction', 'Manufacturing'];

  socialLinks: any = [
    { url: 'https://www.linkedin.com/', name: 'LinkedIn' },
    { url: 'https://www.twitter.com/', name: 'Twitter' },
    { url: 'https://www.facebook.com/', name: 'Facebook' },
  ];

}
